import { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { Input } from '../components/ui/input';
import { Loader2, KeyRound, MailCheck } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setBusy(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setSent(true);
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Something went wrong — try again');
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <Card className="w-full max-w-md" data-testid="forgot-password-card">
        <CardContent className="py-8 px-6 space-y-4 text-center">
          {sent ? (
            <>
              <MailCheck className="h-10 w-10 text-emerald-400 mx-auto" />
              <h1 className="text-xl font-bold">Check your email</h1>
              <p className="text-sm text-muted-foreground" data-testid="forgot-sent-msg">
                If an account exists for <b>{email}</b>, a reset link is on its way (valid 24 hours).
                Signed up with Google? Just use "Continue with Google" on the login page — no password needed.
              </p>
              <Link to="/login" className="text-sm text-indigo-400 hover:underline">Back to login</Link>
            </>
          ) : (
            <>
              <KeyRound className="h-10 w-10 text-indigo-400 mx-auto" />
              <h1 className="text-xl font-bold">Reset your password</h1>
              <p className="text-sm text-muted-foreground">Enter your account email and we'll send you a reset link.</p>
              <form onSubmit={submit} className="space-y-3 text-left">
                <Input type="email" placeholder="you@example.com" value={email} onChange={e => setEmail(e.target.value)} required data-testid="forgot-email-input" />
                <Button type="submit" className="w-full bg-indigo-600 hover:bg-indigo-700 text-white" disabled={busy} data-testid="forgot-submit">
                  {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : 'Send reset link'}
                </Button>
              </form>
              <Link to="/login" className="text-sm text-indigo-400 hover:underline">Back to login</Link>
            </>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
